export default {
  networkError: 'Oops! We encountered a network error, please try again later!',
};
